import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardReportsRoutes = [
	{
		key: "reports-summary",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/reports/summary`,
		component: React.lazy(() => import("views/reward-views/reports/sales-summery/pages/SummaryReport")),
	},
	{
		key: "stock-ledger",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/stocks/ledger`,
		component: React.lazy(() => import("views/reward-views/reports/stock-ledger/pages/StockLedger")),
	},
];
